// extracted by mini-css-extract-plugin
export default {"LeaderboardModal":"LeaderboardModal_LeaderboardModal__w+tD3","title":"LeaderboardModal_title__ZxGsf","title1":"LeaderboardModal_title1__MmjHG"};